import type { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './sphereLogo.svg'
import { SphereIntegrationDetail } from 'Integrations/integrationsConfig/sphere/SphereIntegrationDetail'
import { SphereConfigurationManagement } from 'Integrations/integrationsConfig/sphere/SphereConfigurationManagement/SphereConfigurationManagement'
import { sphereConfigurationLoader } from 'Integrations/integrationsConfig/sphere/sphere.loader'
import { sphereConfigurationMutator } from 'Integrations/integrationsConfig/sphere/sphere.mutator'

export const sphereIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/sphere',
  title: 'Sphere',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false,
    disableSubmitUntilValid: true
  },
  description: 'Automatically calculate sales tax for invoices.',
  components: {
    detail: SphereIntegrationDetail,
    management: SphereConfigurationManagement
  },
  communication: {
    configuration: {
      loader: sphereConfigurationLoader,
      mutator: sphereConfigurationMutator
    }
  }
}

export type SphereIntegrationConfig = {
  apiKey?: string
  obfuscatedApiKey: string
}
